export function initMap() {
    interface MapEntry {
        trigger: string;
        title: string;
        name: string;
        address: string;
        phone: string[];
        email: string[];
    }

    let infoData: Record<string, MapEntry> = {};
    let lastScrollY: number | null = null; // тут будем хранить позицию при открытии

    // Загружаем JSON
	fetch('/local/templates/rtk/files/data.json')
        .then(res => res.json())
        .then((data: Record<string, MapEntry>) => {
            infoData = data;
            initInner();
        })
        .catch(err => console.error('Ошибка загрузки JSON:', err));

    function initInner() {
        const mapContent = document.querySelector<HTMLDivElement>('.map-content')!;

        if (!mapContent) return;

        const titleEl = mapContent.querySelector('.map-title')!;
        const nameEl = mapContent.querySelector('.map-name')!;
        const addressTextEl = mapContent.querySelector('.map-address-text')!;
        const phoneTextEl = mapContent.querySelector('.map-phone-text')!;
        const emailEl = mapContent.querySelector('.map-email')!;
        const closeBtn = mapContent.querySelector<HTMLButtonElement>('.map-content-close')!;
        const closeMapBtn = mapContent.querySelector<HTMLButtonElement>('.button-close-map');

        document.querySelectorAll<SVGPathElement>('svg path[data-id]').forEach(path => {
            path.style.cursor = 'pointer';

            path.addEventListener('click', () => {
                // убрать active со всех
                document.querySelectorAll('svg path[data-id].active')
                    .forEach(el => el.classList.remove('active'));

                path.classList.add('active');

                const dataId = path.getAttribute('data-id');
                if (!dataId) return;

                // ищем объект в JSON
                const entry = Object.values(infoData).find(item => item.trigger === dataId);
                if (!entry) return;

                // вставляем данные
                titleEl.textContent = entry.title;
                nameEl.textContent = entry.name;
                addressTextEl.textContent = entry.address;
                phoneTextEl.innerHTML = entry.phone.join('<br>');
                emailEl.innerHTML = entry.email
                    .map(mail => `<a href="mailto:${mail}" class="map-email-link">${mail}</a>`)
                    .join('');

                // показываем блок и позиционируем
                mapContent.classList.add('active');

                const pathRect = path.getBoundingClientRect();
                const contentRect = mapContent.getBoundingClientRect();

                const top = pathRect.top + pathRect.height / 2 - contentRect.height / 2;
                let left = pathRect.right + 25;

                if (window.innerWidth <= 991) {
                    // мобильный режим
                    const top = pathRect.bottom + 28;
                    console.log(top)
                    mapContent.style.top = `${top}px`;
                    mapContent.style.left = `16px`; // фиксируем отступы
                    mapContent.classList.remove('arrow-left', 'arrow-right');
                    mapContent.classList.add('arrow-top');
                } else {
                    // десктопный режим (как раньше)
                    const top = pathRect.top + pathRect.height / 2 - contentRect.height / 2;
                    let left = pathRect.right + 25;

                    if (left + contentRect.width > window.innerWidth) {
                        left = pathRect.left - contentRect.width - 25;
                        mapContent.classList.add('arrow-right');
                        mapContent.classList.remove('arrow-left', 'arrow-top');
                    } else {
                        mapContent.classList.add('arrow-left');
                        mapContent.classList.remove('arrow-right', 'arrow-top');
                    }

                    mapContent.style.top = `${Math.max(10, top)}px`;
                    mapContent.style.left = `${left}px`;
                }

                // фиксируем текущую прокрутку
                lastScrollY = window.scrollY;
            });
        });

        // крестик
        closeBtn.addEventListener('click', () => {
            closePopup();
        });

        closeMapBtn?.addEventListener('click', () => {
            closePopup();
        });

        // клик вне блока
        document.addEventListener('click', e => {
            if (
                !mapContent.contains(e.target as Node) &&
                !(e.target as HTMLElement).closest('path[data-id]')
            ) {
                closePopup();
            }
        });

        // скролл
        window.addEventListener('scroll', () => {
            if (lastScrollY !== null) {
                if (Math.abs(window.scrollY - lastScrollY) > 30) {
                    closePopup();
                }
            }
        });

        function closePopup() {
            mapContent.classList.remove('active');
            document.querySelectorAll('svg path[data-id].active')
                .forEach(el => el.classList.remove('active'));
            lastScrollY = null; // сброс
        }
    }
}
